import { Core4Age } from '../../../model/Entities';

export const softballCore4Age89: Core4Age = {
    code: '8-9',
    minAge: 8,
    maxAge: 9,
};

export const softballCore4Age1012: Core4Age = {
    code: '10-12',
    minAge: 10,
    maxAge: 12,
};

export const softballCore4Age1314: Core4Age = {
    code: '13-14',
    minAge: 13,
    maxAge: 14,
};

export const softballCore4Age1516: Core4Age = {
    code: '15-16',
    minAge: 15,
    maxAge: 16,
};

export const softballCore4Age1718: Core4Age = {
    code: '17-18',
    minAge: 17,
    maxAge: 18,
};

export const softballCore4AgeCollege: Core4Age = {
    code: 'COLLEGE',
    minAge: 19,
    maxAge: 24,
};

export const softballCore4AgePro: Core4Age = {
    code: 'PRO',
    minAge: 25,
    maxAge: 99,
};
